import { render, staticRenderFns } from "./UserDay.vue?vue&type=template&id=60bf91b0&lang=pug&"
import script from "./UserDay.vue?vue&type=script&lang=js&"
export * from "./UserDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports